import { api, extractApiErrorMessage } from '../api/client';
import { ROUTES } from '../api/routes';

export type ActivationQuizAnswer = {
  perguntaId: string;
  resposta: string;
};

export type ActivationQuizQuestion = {
  id: string;
  pergunta?: string;
  opcoes?: string[];
  [key: string]: unknown;
};

export type ActivationQuizQuestionsResponse = {
  perguntas: ActivationQuizQuestion[];
  nomeAluno?: string;
  [key: string]: unknown;
};

export type ActivationQuizVerifyResponse = {
  aprovado?: boolean;
  dadosDivergentes?: boolean;
  bloqueado?: boolean;
  mensagem?: string;
};

export async function verifyActivationQuiz(
  token: string,
  respostas: ActivationQuizAnswer[],
): Promise<ActivationQuizVerifyResponse> {
  try {
    const { data } = await api.post<ActivationQuizVerifyResponse>(
      ROUTES.auth.quizVerificar,
      { token, respostas },
    );
    return data;
  } catch (err) {
    throw new Error(extractApiErrorMessage(err, 'Erro ao validar respostas.'));
  }
}

export async function getActivationQuizQuestions(
  token: string,
): Promise<ActivationQuizQuestionsResponse> {
  try {
    const { data } = await api.post<ActivationQuizQuestionsResponse>(
      ROUTES.auth.quizPerguntas,
      { token },
    );
    return data;
  } catch (err) {
    throw new Error(extractApiErrorMessage(err, 'Quiz nao disponivel.'));
  }
}

export async function verifyActivationToken<TUserInfo>(
  token: string,
): Promise<TUserInfo> {
  try {
    const { data } = await api.post<TUserInfo>(
      ROUTES.auth.verifyToken,
      { token },
    );
    return data;
  } catch (err) {
    throw err;
  }
}

export async function activateByToken<TResponse>(
  token: string,
): Promise<TResponse> {
  try {
    const { data } = await api.post<TResponse>(
      ROUTES.auth.activateByToken,
      { token },
    );
    return data;
  } catch (err) {
    throw err;
  }
}

export async function activateWithPassword<TResponse>(
  input: { token: string; senha: string; fingerprint: string },
): Promise<TResponse> {
  try {
    const { data } = await api.post<TResponse>(
      ROUTES.auth.activate,
      input,
    );
    return data;
  } catch (err) {
    throw new Error(extractApiErrorMessage(err, 'Erro ao ativar.'));
  }
}

export async function loginAfterActivation(
  email: string,
  senha: string,
): Promise<any> {
  try {
    const { data } = await api.post(
      ROUTES.auth.login,
      { email, senha },
    );
    return data;
  } catch (err) {
    throw new Error(extractApiErrorMessage(err, 'Falha ao autenticar apos ativacao.'));
  }
}
